import './admin-orders.scss';
import { PanelOrderPatient } from '../../components';
import { RightOrdersPanel } from '../../components/utils/right-orders-panel/RightOrdersPanel';

const Index = () => {
  return (
    <div className='view crm-contact-list' >
      <div className='view-wrapper-contact-list'>
        <div style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
          <PanelOrderPatient />
        </div>
        <RightOrdersPanel />
      </div>
    </div>
  );
};

export default Index;
